import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Grid, Container, Box, Card, CardMedia, CardContent,  Skeleton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import IndustryReadyIoT from "../../../../assets/Courses/industryReadyIoTProgram.webp";
import DataScience from "../../../../assets/Courses/aiMachineLearning.webp";
import EmbeddedSystems from "../../../../assets/Courses/industryReadyEmbeddedSystemsProgram.webp";
import Navbar from "./Navebar";
import { fetchPaymentStatus } from '../../../../helper/learnersSubscription';
import useNetworkStatus from "../../../../helper/NetworkStatus";
//import { ShimmerSimpleGallery } from "react-shimmer-effects";

const LearningPathCard = ({ image, title, description, buttonLabel, onClick, isDisabled }) => {
  const coreFeatures = [
    "Access to all Courses and Projects",
    "1-to-1 Doubt Sessions: 2 hours per month",
    title === "Industry Ready Embedded Systems Program"
      ? "Guaranteed internships with ₹30,000 stipend"
      : "Guaranteed internships with ₹40,000 stipend"
  ];

  return (
   <Grid item xs={12} sm={4} align="start">
      <Card sx={{ boxShadow: 3, borderRadius: '8px', overflow: 'hidden', backgroundColor: "#fff", width : '100%' }}>
        <CardMedia component="img" width="250px" height="200" image={image} alt={title} sx={{ objectFit: 'cover' }} />
        <CardContent sx={{ p: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#052659', fontSize: "0.9rem",}} gutterBottom>
            {title}
          </Typography>
          <Typography variant="body1" sx={{ color: '#333', fontSize: "1rem" }}>
          {description}
        </Typography>

          {buttonLabel === "Enroll Now" && (
            <Box sx={{ mt: 2 }}>
              {coreFeatures.map((feature, i) => (
                <Typography key={i} variant="body2" sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1, color: "text.secondary" }}>
                  <FontAwesomeIcon icon={faCheck} color="green" />
                  {feature}
                </Typography>
              ))}
            </Box>
          )}

          <Button
            variant={isDisabled ? "outlined" : "contained"}
            color={isDisabled ? "secondary" : "primary"}
            sx={{
              width : '100%',
              background: !isDisabled ? 'linear-gradient(135deg, #5483B3, #052659)' : undefined,
              '&:hover': !isDisabled ? { background: 'linear-gradient(135deg, #052659, #345A80)' } : undefined,
              mt: 2
            }}
            onClick={onClick}
            disabled={isDisabled}
          >
            {buttonLabel}
          </Button>
        </CardContent>
      </Card>
    </Grid>
  );
};

const LearningPath = () => {
  const navigate = useNavigate();
  const { isOnline } = useNetworkStatus();
  const [loading, setLoading] = useState(true);
  const [paymentStatus, setPaymentStatus] = useState({ subcribe: false, iot: false, dataScience: false, embedded: false });
  const [clickedPaths, setClickedPaths] = useState(
    JSON.parse(localStorage.getItem("clickedPaths")) || {}
  );

  useEffect(() => {
  const timer = setTimeout(() => {
    setLoading(false);
  }, 1000); // 1-second delay
  return () => clearTimeout(timer); // cleanup
  }, []);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (!storedToken) {
      navigate("/learners/signin", { replace: true });
    } else {
      fetchPaymentStatus(storedToken)
        .then((status) => {
          setPaymentStatus(status);

          //Sync resume flags from localStorage
          const savedPaths = JSON.parse(localStorage.getItem("clickedPaths")) || {
            iot: false,
            dataScience: false,
            embedded: false
          };
          setClickedPaths(savedPaths);
        })
        .catch((error) => {
          console.error(error);
      });
    }
  }, [navigate]);

  const handleLearningPathClick = (id, link) => {
    //console.log(`Button clicked for ${id}, navigating to: ${link}`); // Log the button click event
  
     if (!link || link === "#") {
    return { status: "invalid_link", id, link };
  }

  if (link.startsWith("http")) {
    // External URL: open in new tab
    // window.open(link, "_blank", "noopener,noreferrer");
    window.location.href = link;

    // You may or may not want to update clickedPaths / paymentStatus for external links.
    return { status: "external_link_opened", id, link };
  } else {
    // Internal route: navigate via react-router
    localStorage.setItem("selectedPath", link);
    navigate(link);
  
      let response;
      if (paymentStatus[id]) {
        const updatedPaths = { ...clickedPaths, [id]: true };
        setClickedPaths(updatedPaths);
        localStorage.setItem("clickedPaths", JSON.stringify(updatedPaths));
        response = { status: "resumed", id, link };
      } else {
        // Update localStorage when a user starts a new course
        const updatedPaymentStatus = { ...paymentStatus, [id]: true };
        setPaymentStatus(updatedPaymentStatus);
        localStorage.setItem("paymentStatus", JSON.stringify(updatedPaymentStatus));
        response = { status: "enrolled", id, link };
      }
  
      //console.log("Response:", response); // Log the response
      return response; // Return the response
    }
  };

  const learningPaths = [
    {
      id: "iot",
      image: IndustryReadyIoT,
      title: "Industry Ready IoT Program",
      description: "Master the technology behind smart, connected solutions.",
      buttonLabel: paymentStatus.iot ? (clickedPaths.iot ? "Resume" : "Start") : "Enroll Now",
      isDisabled: false,
      link: paymentStatus.iot ? "/learners/dashboard/internetofthings" : "https://site.huebits.in/internet-of-things"
    },
    {
      id: "dataScience",
      image: DataScience,
      title: "Industry Ready AI and ML Program",
      description: "Harness the power of data to drive innovation and decisions.",
      buttonLabel: paymentStatus.dataScience ? (clickedPaths.dataScience ? "Resume" : "Start") : "Enroll Now",
      isDisabled: false,
      //link: paymentStatus.dataScience ? "#" : "/learners/data-science"
      link: paymentStatus.dataScience ? "/learners/data-science-dashboard/data-science-learningpath" : "https://site.huebits.in/ai-machine-learning"
    },
    {
      id: "embedded",
      image: EmbeddedSystems,
      title: "Industry Ready Embedded Systems Program",
      description: "Build intelligent systems shaping the future of technology.",
      buttonLabel: paymentStatus.embedded ? (clickedPaths.embedded ? "Resume" : "Start") : "Enroll Now",
      isDisabled: false,
      //link: paymentStatus.embedded ? "#" : "/learners/embedded-systems"
      link: paymentStatus.embedded ? "/learners/embedded-systems-dashboard/embedded-systems-learningpath" : "https://site.huebits.in/embedded-systems"
    },
    // {
    //   id: "embedded",
    //   image: EmbeddedSystems,
    //   title: "Industry Ready Embedded Systems Program",
    //   description: "Build intelligent systems shaping the future of technology.",
    //   buttonLabel: paymentStatus.embedded ? "Coming Soon" : clickedPaths.embedded ? "Resume" : "Enroll Now",
    //   isDisabled: paymentStatus.embedded,
    //   link: "/learners/embedded-systems"
    // }

  ];
  return (
    <>
    {isOnline ? (
    loading ? (
      // <ShimmerSimpleGallery card imageHeight={180} row={3} col={3} gap={20} />
         <Grid container spacing={4} justifyContent="center" sx={{ padding: 4 }}>
      {[1, 2, 3].map((item) => (
        <Grid item xs={12} sm={6} md={4} key={item}>
          <Skeleton variant="rectangular" width="100%" height="60%" sx={{ borderRadius: 2 }} />
          <Skeleton height={30} sx={{ mt: 2 }} />
          <Skeleton height={20} width="80%" />
          <Skeleton height={40} width="100%" sx={{ mt: 2 }} />
        </Grid>
      ))}
    </Grid>
    ) : (
    <div className="students-flex">
      <Navbar />
      <div className="mylearningpaths">
      <div>
        <Container>
         <Typography
            variant="body1"
            align="center"
            gutterBottom
            sx={{
              fontWeight: 700,
              color: "#052659",
              fontSize: { xs: "1rem", sm: "1.4rem" },
              mt: "40px",
              mb: "10px",
              textAlign: "center",
            }}
          >
            Explore Your Future with Our Industry-Ready Programs
          </Typography>

          <Typography
            variant="body1"
            align="center"
            paragraph
            sx={{
              color: "#333",
              fontSize: { xs: "1rem", sm: "1.2rem" },
              fontWeight: 400,
              mb: "40px",
              textAlign: "center",
            }}
          >
            Thank you for joining us! Choose your industry-ready program.
          </Typography>
          <Grid container spacing={4} justifyContent="center">
            {learningPaths.map((path) => (
              <LearningPathCard
                key={path.id}
                image={path.image}
                title={path.title}
                description={path.description}
                buttonLabel={path.buttonLabel}
                isDisabled={path.isDisabled}
                onClick={() => handleLearningPathClick(path.id, path.link)}
              />
            ))}
          </Grid>
          <Box mt={5}>
            <Typography variant="body1" align="center" paragraph sx={{ color: '#333', paddingBottom : '40px' }}>
              Your journey begins here. Select your program and take the first step today!
            </Typography>
          </Box>
        </Container>
        </div>
      </div>
    </div>
    )
    ) : (
      // <ShimmerSimpleGallery card imageHeight={180} row={3} col={3} gap={20} />
         <Grid container spacing={4} justifyContent="center" sx={{ padding: 4 }}>
      {[1, 2, 3].map((item) => (
        <Grid item xs={12} sm={6} md={4} key={item}>
          <Skeleton variant="rectangular" width="100%" height="60%" sx={{ borderRadius: 2 }} />
          <Skeleton height={30} sx={{ mt: 2 }} />
          <Skeleton height={20} width="80%" />
          <Skeleton height={40} width="100%" sx={{ mt: 2 }} />
        </Grid>
      ))}
    </Grid>
    )}
  </>
  );
};

export default LearningPath;